import React from "react";


const MapLegend = (props) => {
  return (
        <div>
        <ul>

        {props.data.map((value, index) => (
            <li key={index}>
                <input id={index} defaultChecked={value.checked} onChange={() => props.handleChange(index)} type="checkbox"/> &nbsp; 
                <span style={{background: value.color}} className={'legend-box'}></span> <b>{value.text}</b>
            </li>
        ))}

        </ul>
    </div>

  );
};

export default MapLegend;
